import React from 'react';
import t from 'prop-types';

var PieBotoneraVisor = function PieBotoneraVisor(_ref) {
  var children = _ref.children;
  return React.createElement('div', {
    className: 'pieBotoneraVisorImagenes'
  }, children);
};

PieBotoneraVisor.propTypes = process.env.NODE_ENV !== "production" ? {
  children: t.any
} : {};
export default PieBotoneraVisor;